import {action, computed, makeObservable, observable} from "mobx";
import CommonStore from "../../../../stores/CommonStore";
import { ProductService } from "../../../../service/topup/ProductService";
import TopupProduct from "../../../../entities/productOrder/topup/TopupProduct";

class TopupSalePriceStore {

    public topupProducts: TopupProduct[];
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore) {
        this.topupProducts = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            topupProducts: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return this.topupProducts.length === 0;
    }

    @action
    public async getTopupProducts() {
        const response = await ProductService.getAll();
        if (response.success && response.data) {
            this.topupProducts = response.data
        }
    }

}

export default TopupSalePriceStore;